export default () => ({
  init() {
    // Monitor for currency changes by checking price elements periodically
    let lastCurrencyState = this.getCurrentCurrencyState();

    const checkInterval = setInterval(() => {
      const currentCurrencyState = this.getCurrentCurrencyState();

      // Check if currency has changed from Euro to localized
      if (lastCurrencyState.isEuro && !currentCurrencyState.isEuro) {
        console.log(
          "🔄 Currency changed from Euro to localized - refreshing quick shop"
        );
        this.refreshQuickShopIfOpen();
      }

      lastCurrencyState = currentCurrencyState;
    }, 1000); // Check every second

    // Stop monitoring after 10 seconds
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 10000);
  },

  getCurrentCurrencyState() {
    const priceElement = document.querySelector(
      ".price-item--sale, .price-item--last"
    );
    if (!priceElement) {
      return { isEuro: false, priceText: "No price found" };
    }

    const priceText = priceElement.textContent || priceElement.innerText;
    const isEuro = priceText.includes("€") || priceText.includes("EUR");

    return {
      isEuro,
      priceText: priceText.trim(),
      timestamp: Date.now(),
    };
  },

  refreshQuickShopIfOpen() {
    const quickShopModal = document.querySelector(".quick-shop-modal");
    if (!quickShopModal) return;

    const isModalVisible =
      quickShopModal.style.display !== "none" &&
      !quickShopModal.classList.contains("hidden");

    if (isModalVisible) {
      // Find the current product handle in the modal
      const productLink = quickShopModal.querySelector('a[href*="/products/"]');
      if (productLink) {
        const productHandle = this.extractProductHandle(productLink.href);
        console.log("🔄 Refreshing quick shop product:", productHandle);

        // Dispatch custom event to refresh the quick shop
        const refreshEvent = new CustomEvent("refresh-quick-shop", {
          detail: { productHandle },
        });
        document.dispatchEvent(refreshEvent);
      }
    }
  },

  extractProductHandle(productUrl) {
    const match = productUrl.match(/\/products\/([^\/\?]+)/);
    return match ? match[1] : null;
  },
});
